import { EditableField } from "../action-item/EditableField";
import { HeaderControls } from "./HeaderControls";
import { useIsMobile } from "../../hooks/use-mobile";

interface DetailTitleProps {
  title: string;
  onTitleChange: (title: string) => void;
  onDelete: () => void;
  placeholder?: string;
}

export function DetailTitle({ 
  title, 
  onTitleChange, 
  onDelete,
  placeholder = "Untitled"
}: DetailTitleProps) {
  const isMobile = useIsMobile();

  return (
    <div className="space-y-4 md:space-y-0">
      {isMobile && (
        <HeaderControls
          onDelete={onDelete}
          className="justify-between"
        />
      )}
      <div className="grid grid-cols-1 md:grid-cols-4 items-start gap-4">
        <div className="col-span-3">
          <EditableField
            value={title}
            onChange={onTitleChange}
            type="title"
            className="text-xl md:text-2xl font-bold border-none bg-transparent p-0 h-auto focus-visible:ring-0 w-full text-foreground break-words"
            placeholder={placeholder}
            showToast={false}
          />
        </div>
        {!isMobile && (
          <div className="flex justify-end">
            <HeaderControls
              onDelete={onDelete}
            />
          </div>
        )}
      </div>
    </div>
  );
}